import React from 'react';
import { Color } from '../styles';
import { createStackNavigator } from '@react-navigation/stack';
import { Modals, Screens, Stacks } from '../constants/ScreenNames';

import LoginScreen from '../screens/LoginScreen';
import RebookScreen from '../screens/RebookScreen';

import AACalendarModal from '../components/modals/AACalendarModal/AACalendarModal';
import CalendarModal from '../components/modals/CalendarModal';
import AirFilterModal from '../components/modals/AirFilterModal';
import AirFilterModalCloud from '../components/modals/AirFilterModalCloud';
import CarFilterModal from '../components/modals/CarFilterModal';
import HotelFilterModal from '../components/modals/HotelFilterModal';
import RailFilterModal from '../components/modals/RailFilterModal';
import TripFilterModal from '../components/modals/TripFilterModal';
import TripSummaryModal from '../components/modals/TripSummaryModal';
import { defaultStackHeaderOptions } from '../utils/defaultNavOptions';

import StationAutoCompleteModal from '../components/modals/StationAutoCompleteModal';
import RebookModal from '../components/modals/RebookModal';
import ResearchWidgetModal from '../components/modals/ResearchWidgetModal';
import SearchTripOptionsModal from '../components/modals/SearchTripOptionsModal';
import AgentContactScreen from '../screens/AgentContactScreen';

import LanguageModal from '../components/modals/LanguageModal';
import ProfileModal from '../components/modals/ProfileModal';
import CreditCardModal from '../components/modals/CreditCardModal';
import LoyaltyModal from '../components/modals/LoyaltyModal';
import PassengerLoyaltyForm from '../components/modals/PassengerLoyaltyForm';
import PassportModal from '../components/modals/PassportModal';
import PasswordModal from '../components/modals/PasswordModal';
import AirSeatModal from '../components/modals/TripHub/AirSeatModal';
import DirectionModal from '../components/modals/TripHub/DirectionModal';
import RailSeatModal from '../components/modals/TripHub/RailSeatModal';
import RideShareModal from '../components/modals/TripHub/RideShareModal';
import AddReviewModal from '../components/modals/TripHub/AddReviewModal';
import MeetingModal from '../components/modals/TripHub/MeetingModal';
import MeetingFormModal from '../components/modals/TripHub/MeetingFormModal';
import ActivitiesWebModal from '../components/modals/TripHub/ActivitiesWebModal';
import CheckInWebModal from '../components/modals/TripHub/CheckInWebModal';
import TrackTrainWebModal from '../components/modals/TripHub/TrackTrainWebModal';
import InviteTravelerModal from '../components/modals/TripHub/InviteTravelerModal';
import EmailItineraryModal from '../components/modals/EmailItineraryModal';
import TripExpenseModal from '../components/modals/TripExpenseModal';
import TripExpenseAddModal from '../components/modals/TripExpense/TripExpenseAddModal';
import CategorySelectorModal from '../components/modals/TripExpense/CategorySelectorModal';
import AttendeesSelectorModal from '../components/modals/TripExpense/AttendeesSelectorModal';
import TravelSettingsModal from '../components/modals/TripEvent/TravelSettingsModal';
import EventSettingsModal from '../components/modals/TripEvent/EventSettingsModal';
import EventPreviewModal from '../components/modals/TripEvent/EventPreviewModal';
import EventEditModal from '../components/modals/TripEvent/EventEditModal';
import TimePickerModal from '../components/modals/TimePickerModal';
import SelectorModal from '../components/modals/SelectorModal';
import InvitationTravelerModal from '../components/modals/TripHub/InvitationTravelerModal';
import InvitePermissionsModal from '../components/modals/TripHub/InvitePermissionsModal';
import TravelerSafetyModal from '../components/modals/TripHub/TravelerSafetyModal';

import ChangeResModal from '../components/modals/ChangeResModal';
import ChangeResWidget from '../components/modals/ChangeResWidget';
import { useTranslation } from 'react-i18next';
import { useComponentTKey } from '../i18n';
import { MainNavigator } from './MainStackNavigator';
import InvitationModal from '../components/modals/InvitationModal';
import { REBOOK_ENABLED } from '../config/env';
import AALoginScreenModal from '../components/modals/AALoginScreenModal';
import OneWayBXAlertModal from '../components/modals/OneWayBXAlertModal';
import PrivacyScreen from '../screens/PrivacyScreen';
import TermsScreen from '../screens/TermsScreen';
import MessagesModal from '../components/modals/MessagesModal';
import HomepageOnewayModal from '../components/HomepageOnewayModal';
import ReceiptScannerModal from '../components/modals/TripExpense/ReceiptScannerModal';
import CreateExpenseModal from '../components/modals/TripExpense/CreateExpenseModal';
import ReceiptVaultModal from '../components/modals/TripExpense/ReceiptVaultModal';
import ViewReceiptModal from '../components/modals/TripExpense/ViewReceiptModal';
import ExpenseReportCardModal from '../components/expense/ExpenseReportCardModal';
import ExpenseFormStepTwo from '../components/ExpenseWidget/ExpenseFormStepTwo';
import ExpenseParticipantModal from '../components/ExpenseWidget/ExpenseParticipant';
import PaymentModal from '../components/modals/TripExpense/PaymentModal';
import UserActivationScreen from '../screens/UserActivationScreen';

const headerPrimaryColor = {
  headerStyle: {
    backgroundColor: Color.primary,
  },
  headerTintColor: Color.accent,
  headerTitleStyle: {
    color: Color.accent,
  },
};

const AuthStackNavigator = createStackNavigator();
export const AuthStack = () => {
  return (
    <AuthStackNavigator.Navigator
      mode="modal"
      headerMode="screen"
      screenOptions={{ headerShown: false }}
    >
      {REBOOK_ENABLED ? (
        <>
          <AuthStackNavigator.Screen
            name={Screens.Rebook}
            component={RebookScreen}
            options={{
              title: 'Rebook',
              cardStyle: { backgroundColor: Color.accent },
            }}
          />
          <AuthStackNavigator.Screen
            name={Modals.RebookModal}
            component={RebookModal}
            options={{
              title: 'Rebook',
              headerShown: true,
              cardStyle: { backgroundColor: Color.accent },
            }}
          />
        </>
      ) : (
        <>
          <AuthStackNavigator.Screen
            name={Modals.Login}
            component={LoginScreen}
            options={{
              title: 'Login',
              cardStyle: { backgroundColor: Color.accent },
            }}
          />
          <AuthStackNavigator.Screen
            name={Screens.UserActivation}
            component={UserActivationScreen}
            options={{
              title: 'Activate Account',
              cardStyle: { backgroundColor: Color.accent },
            }}
          />
        </>
      )}
    </AuthStackNavigator.Navigator>
  );
};

const RootStackNavigator = createStackNavigator();
export const RootNavigator = () => {
  const { t } = useTranslation();
  const { tKey } = useComponentTKey('MainNavigator');
  return (
    <RootStackNavigator.Navigator
      mode="modal"
      headerMode="screen"
      screenOptions={defaultStackHeaderOptions}
    >
      <RootStackNavigator.Screen
        name={Stacks.MainStack}
        component={MainNavigator}
        options={{
          title: '',
          headerShown: false,
          cardStyle: { backgroundColor: Color.accent },
        }}
      />
      <RootStackNavigator.Screen
        name={Modals.Calendar}
        component={CalendarModal}
        options={{ title: t(tKey('SelectDates')) }}
      />
      <RootStackNavigator.Screen
        name={Modals.AACalendarModal}
        component={AACalendarModal}
        options={{ title: t(tKey('SelectDates')) }}
      />
      <RootStackNavigator.Screen
        name={Modals.ProfileModal}
        component={ProfileModal}
        options={{ title: t(tKey('EditProfile')) }}
      />
      <RootStackNavigator.Screen
        name={Modals.CreditCardModal}
        component={CreditCardModal}
        options={{ title: t(tKey('AddEditCreditCard')) }}
      />
      <RootStackNavigator.Screen
        name={Modals.LoyaltyModal}
        component={LoyaltyModal}
        options={{ title: t(tKey('AddEditLoyalty')) }}
      />

      <RootStackNavigator.Screen
        name={Modals.PassengerLoyaltyForm}
        component={PassengerLoyaltyForm}
        options={{ title: t(tKey('AddEditLoyalty')) }}
      />
      <RootStackNavigator.Screen
        name={Modals.PassportModal}
        component={PassportModal}
        options={{ title: t(tKey('EditPassportGovtInfo')) }}
      />
      <RootStackNavigator.Screen
        name={Modals.PasswordModal}
        component={PasswordModal}
        options={{ title: t(tKey('ChangePasword')) }}
      />
      <RootStackNavigator.Screen
        name={Modals.AirFilterModal}
        component={AirFilterModal}
        options={{ title: t(tKey('FilterFlights')) }}
      />
      <RootStackNavigator.Screen
        name={Modals.AirFilterModalCloud}
        component={AirFilterModalCloud}
        options={{ title: t(tKey('FilterFlights')) }}
      />
      <RootStackNavigator.Screen
        name={Modals.HotelFilterModal}
        component={HotelFilterModal}
        options={{ title: t(tKey('FilterHotels')) }}
      />
      <RootStackNavigator.Screen
        name={Modals.CarFilterModal}
        component={CarFilterModal}
        options={{ title: t(tKey('FilterCars')) }}
      />
      <RootStackNavigator.Screen
        name={Modals.RailFilterModal}
        component={RailFilterModal}
        options={{ title: t(tKey('FilterRail')) }}
      />
      <RootStackNavigator.Screen
        name={Modals.TripFilterModal}
        component={TripFilterModal}
        options={{ title: t(tKey('FilterTrips')) }}
      />
      <RootStackNavigator.Screen
        name={Modals.ChangeResModal}
        component={ChangeResModal}
        options={{ title: 'Change Trip' }}
      />
      <RootStackNavigator.Screen
        name={Modals.InvitationModal}
        component={InvitationModal}
        options={{ title: 'Invitation' }}
      />
      <RootStackNavigator.Screen
        name={Modals.ChangeResWidget}
        component={ChangeResWidget}
        options={{ title: 'Change Trip Segments' }}
      />
      <RootStackNavigator.Screen
        name={Modals.StationAutoCompleteModal}
        component={StationAutoCompleteModal}
      />
      <RootStackNavigator.Screen
        name={Modals.ResearchWidgetModal}
        component={ResearchWidgetModal}
        options={{ title: t(tKey('ModifySearch')) }}
      />
      <RootStackNavigator.Screen
        name={Modals.SearchTripOptionsModal}
        component={SearchTripOptionsModal}
        options={{ title: t(tKey('Options')) }}
      />
      <RootStackNavigator.Screen
        name={Modals.TripSummaryModal}
        component={TripSummaryModal}
        options={{ title: t(tKey('TripSummary')) }}
      />
      <RootStackNavigator.Screen
        name={Modals.AgentContact}
        component={AgentContactScreen}
        options={{ title: t(tKey('ContactAgent')) }}
      />
      <RootStackNavigator.Screen
        name={Modals.AirSeatModal}
        component={AirSeatModal}
        options={{ title: t(tKey('SeatMap')) }}
      />
      <RootStackNavigator.Screen
        name={Modals.RailSeatModal}
        component={RailSeatModal}
        options={{ title: t(tKey('SeatMap')) }}
      />
      <RootStackNavigator.Screen
        name={Modals.RideShareModal}
        component={RideShareModal}
        options={{ title: t(tKey('RideShare')) }}
      />
      <RootStackNavigator.Screen
        name={Modals.AddReviewModal}
        component={AddReviewModal}
        options={{ title: 'Rate Your Hotel' }}
      />
      <RootStackNavigator.Screen
        name={Modals.DirectionModal}
        component={DirectionModal}
        options={{ title: t(tKey('Directions')) }}
      />
      <RootStackNavigator.Screen
        name={Modals.MeetingModal}
        component={MeetingModal}
        options={{ title: t(tKey('EditActivity')), ...headerPrimaryColor }}
      />
      <RootStackNavigator.Screen
        name={Modals.MeetingFormModal}
        component={MeetingFormModal}
        options={{ title: t(tKey('AddActivity')), ...headerPrimaryColor }}
      />
      <RootStackNavigator.Screen
        name={Modals.ActivitiesWebModal}
        component={ActivitiesWebModal}
        options={{ title: t(tKey('Activities')), ...headerPrimaryColor }}
      />
      <RootStackNavigator.Screen
        name={Modals.CheckInWebModal}
        component={CheckInWebModal}
        options={{ title: t(tKey('CheckIn')), ...headerPrimaryColor }}
      />
      <RootStackNavigator.Screen
        name={Modals.TrackTrainWebModal}
        component={TrackTrainWebModal}
        options={{ title: t(tKey('TrackTrain')), ...headerPrimaryColor }}
      />
      <RootStackNavigator.Screen
        name={Modals.InviteTravelerModal}
        component={InviteTravelerModal}
        options={{ title: t(tKey('InviteTravelers')) }}
      />
      <RootStackNavigator.Screen
        name={Modals.EmailItineraryModal}
        component={EmailItineraryModal}
        options={{ title: t(tKey('EmailItinerary')) }}
      />
      <RootStackNavigator.Screen
        name={Modals.TripExpenseModal}
        component={TripExpenseModal}
        options={{ headerShown: false }}
      />
      <RootStackNavigator.Screen
        name={Modals.TripExpenseAddModal}
        component={TripExpenseAddModal}
        options={{ title: t(tKey('CreateNewExpense')) }}
      />
      <RootStackNavigator.Screen
        name={Modals.CategorySelectorModal}
        component={CategorySelectorModal}
        options={{ title: t(tKey('SelectCategory')) }}
      />
      <RootStackNavigator.Screen
        name={Modals.AttendeesSelectorModal}
        component={AttendeesSelectorModal}
        options={{ title: t(tKey('AddAttendess')) }}
      />
      <RootStackNavigator.Screen
        name={Modals.TravelSettingsModal}
        component={TravelSettingsModal}
        options={{ title: 'Travel Settings' }}
      />
      <RootStackNavigator.Screen
        name={Modals.EventSettingsModal}
        component={EventSettingsModal}
        options={{ title: 'Event Settings' }}
      />
      <RootStackNavigator.Screen
        name={Modals.EventPreviewModal}
        component={EventPreviewModal}
        options={{ title: 'Event Preview Mode' }}
      />
      <RootStackNavigator.Screen
        name={Modals.EventEditModal}
        component={EventEditModal}
        options={{ title: 'Event Event Settings' }}
      />
      <RootStackNavigator.Screen
        name={Modals.InvitationTravelerModal}
        component={InvitationTravelerModal}
        options={{ title: 'Create Group' }}
      />
      <RootStackNavigator.Screen
        name={Modals.TimePickerModal}
        component={TimePickerModal}
        options={{ title: 'Select Times' }}
      />
      <RootStackNavigator.Screen
        name={Modals.SelectorModal}
        component={SelectorModal}
        options={{ title: 'Select One Option' }}
      />
      <RootStackNavigator.Screen
        name={Modals.InvitePermissionsModal}
        component={InvitePermissionsModal}
        options={{ title: 'Invite Permissions' }}
      />
      <RootStackNavigator.Screen
        name={Modals.TravelerSafetyModal}
        component={TravelerSafetyModal}
        options={{ title: t(tKey('TravelerSafety')) }}
      />
      <RootStackNavigator.Screen
        name={Modals.LanguageModal}
        component={LanguageModal}
        options={{ title: t(tKey('Language')) }}
      />

      <RootStackNavigator.Screen
        name={Modals.AALoginScreen}
        component={AALoginScreenModal}
        options={{ title: 'Login' }}
      />

      <RootStackNavigator.Screen
        name={Modals.OneWayBXAlertModal}
        component={OneWayBXAlertModal}
        options={{ title: 'Award Exception' }}
      />
      <RootStackNavigator.Screen
        name={Screens.Privacy}
        component={PrivacyScreen}
        options={{ title: 'Privacy Policy' }}
      />
      <RootStackNavigator.Screen
        name={Screens.Terms}
        component={TermsScreen}
        options={{ title: 'Terms Of User' }}
      />

      <RootStackNavigator.Screen
        name={Modals.MessagesModal}
        component={MessagesModal}
        options={{ title: 'Message' }}
      />

      <RootStackNavigator.Screen
        name={Modals.ReceiptScannerModal}
        component={ReceiptScannerModal}
        options={{ title: 'Scanning Receipt' }}
      />

      <RootStackNavigator.Screen
        name={Modals.CreateExpenseModal}
        component={CreateExpenseModal}
        options={{}} // Title should be set only from that screen
      />

      <RootStackNavigator.Screen
        name={Modals.ReceiptVaultModal}
        component={ReceiptVaultModal}
        options={{ title: 'Uploads' }}
      />

      <RootStackNavigator.Screen
        name={Modals.ViewReceiptModal}
        component={ViewReceiptModal}
        options={{ title: 'View Receipt' }}
      />
      <RootStackNavigator.Screen
        name={Modals.ExpenseReportCardModal}
        component={ExpenseReportCardModal}
        options={{ title: 'ExpenseReportModal' }}
      />

      <RootStackNavigator.Screen
        name={Modals.HomepageOnewayModal}
        component={HomepageOnewayModal}
        options={{
          title: '',
          cardStyle: { backgroundColor: Color.accent },
        }}
      />

      <RootStackNavigator.Screen
        name={Modals.ExpenseFormStepTwo}
        component={ExpenseFormStepTwo}
        options={{
          title: 'Complete your expense',
          cardStyle: { backgroundColor: Color.accent },
        }}
      />

      <RootStackNavigator.Screen
        name={Modals.ExpenseParticipantModal}
        component={ExpenseParticipantModal}
        options={{
          title: 'Add Participants',
          cardStyle: { backgroundColor: Color.accent },
        }}
      />

      <RootStackNavigator.Screen
        name={Modals.PaymentModal}
        component={PaymentModal}
        options={{
          title: 'Select Payment Method',
          cardStyle: { backgroundColor: Color.accent },
        }}
      />
    </RootStackNavigator.Navigator>
  );
};
